"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var formik_1 = require("formik");
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var api_service_1 = require("../../../api/api_service");
var button_component_1 = require("../../../common/buttons/button_component");
var dropdownFields_1 = require("../../../constants/dropdownFields");
var FECreationTabConstant_1 = require("../../../constants/FECreationTabConstant");
var formFieldConstants_1 = require("../../../constants/formFieldConstants");
var route_path_1 = require("../../../constants/route_path");
var schema_1 = require("../../../constants/schema");
var lodash_1 = require("./../../../utils/lodash");
var appConstants_1 = require("../../../constants/appConstants");
var FE_BillingDetailsForm = function (_a) {
    var initialValues = _a.initialValues, saveFormData = _a.saveFormData, enableSendItForApproval = _a.enableSendItForApproval, fepersonalDetails = _a.fepersonalDetails, sendItForApproval = _a.sendItForApproval, updateValue = _a.updateValue, value = _a.value, onBoardingStatus = _a.onBoardingStatus, FEIdToBeReplaced = _a.FEIdToBeReplaced, labs = _a.labs;
    var _b = React.useState('NO'), buttonState = _b[0], setButtonState = _b[1];
    var user_id = (0, react_redux_1.useSelector)(function (state) { return state.FE_creation_reducer; }).user_id;
    var billing_modules = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList; }).billing_modules;
    var nav = (0, react_router_dom_1.useNavigate)();
    var editUserId = (0, react_router_dom_1.useParams)().id;
    var location = (0, react_router_dom_1.useLocation)();
    var onChangeHandler = function (e) {
        if (e.target.checked) {
            setButtonState('YES');
        }
        else {
            setButtonState('NO');
        }
    };
    var getDropdownList = function (filedname) {
        switch (filedname) {
            case 'billingModule':
                return billing_modules;
            default:
                return [];
        }
    };
    var formSubmitHandler = function (values) {
        var _a;
        if (lodash_1.default.isEqual(values, initialValues)) {
            if (onBoardingStatus === 1) {
                if (location.pathname.includes('edit')) {
                    nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.editFE, "/").concat(editUserId, "/").concat(FECreationTabConstant_1.CreationTabConstants.INVENTORYDETAILS), { replace: true });
                    updateValue(FECreationTabConstant_1.CreationTabConstants.INVENTORYDETAILS);
                }
                else {
                    nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.addFE, "/").concat(editUserId, "/").concat(FECreationTabConstant_1.CreationTabConstants.INVENTORYDETAILS));
                    updateValue(FECreationTabConstant_1.CreationTabConstants.INVENTORYDETAILS);
                }
            }
            else {
                react_hot_toast_1.default.error('No change in the details');
            }
            return;
        }
        if (onBoardingStatus === 1) {
            saveFormData(values, false);
        }
        else {
            var payload = {};
            var personalDetailsObj = {};
            personalDetailsObj['first_name'] = fepersonalDetails.firstName
                .trim()
                .toUpperCase();
            personalDetailsObj['last_name'] = fepersonalDetails.lastName
                .trim()
                .toUpperCase();
            personalDetailsObj['dob'] =
                fepersonalDetails.dob != '' &&
                    fepersonalDetails.dob != null &&
                    fepersonalDetails.dob != undefined
                    ? moment(fepersonalDetails.dob).format('YYYY-MM-DD')
                    : '';
            personalDetailsObj['mobile'] = fepersonalDetails.mobileNumber;
            personalDetailsObj['email'] = fepersonalDetails.email
                .trim()
                .toUpperCase();
            personalDetailsObj['gender'] =
                fepersonalDetails.gender != null ? fepersonalDetails.gender.label : '';
            personalDetailsObj['avatar'] = fepersonalDetails.uploadPhoto;
            personalDetailsObj['emergency_mobile'] =
                fepersonalDetails.emergencyContactNo;
            personalDetailsObj['reference_name1'] =
                fepersonalDetails.referenceContactName1.trim().toUpperCase();
            personalDetailsObj['reference_name2'] =
                fepersonalDetails.referenceContactName2.trim().toUpperCase();
            personalDetailsObj['reference_mobile1'] =
                fepersonalDetails.referenceMobileNumber1;
            personalDetailsObj['reference_mobile2'] =
                fepersonalDetails.referenceMobileNumber2;
            var billingDetails = {};
            billingDetails['billing_module'] =
                values.billingModule != null ? values.billingModule.label : '';
            if (((_a = values.billingModule) === null || _a === void 0 ? void 0 : _a.label) !== 'No Billing') {
                billingDetails['billing_type'] =
                    values.billingType != null ? values.billingType : '';
                billingDetails['billing_cost'] =
                    values.billingCost != null ? values.billingCost : '';
            }
            if (FEIdToBeReplaced) {
                payload['personal_details'] = personalDetailsObj;
                payload['billing_details'] = billingDetails;
                payload['is_final_submit'] = false;
                payload['user_id'] = user_id;
                payload['is_replacement'] = true;
                payload['replacement_fe_id'] = parseInt(FEIdToBeReplaced);
            }
            else {
                payload['personal_details'] = personalDetailsObj;
                payload['billing_details'] = billingDetails;
                payload['is_final_submit'] = false;
                payload['user_id'] = user_id;
            }
            api_service_1.api_service
                .post({
                endPoint: api_service_1.api_service.api_urls.FE_CREATION,
                payLoad: payload,
                domain: process.env.VENDOR_BASE_URL,
            })
                .then(function (res) {
                var _a, _b, _c;
                if (res.data.statusCode === 200) {
                    react_hot_toast_1.default.success(res.data.message);
                    saveFormData(values, false);
                }
                else {
                    react_hot_toast_1.default.error((_c = (_b = (_a = res.data.errors) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : res.data.message) !== null && _c !== void 0 ? _c : 'An error occurred');
                }
            })
                .catch(function (err) {
                react_hot_toast_1.default.error(err.data.errors);
            });
        }
    };
    var backButtonHandler = function () {
        if (onBoardingStatus === 1) {
            updateValue(value - 1);
        }
        else {
            if (location.pathname.includes('edit')) {
                nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.editFE, "/").concat(editUserId, "/").concat(FECreationTabConstant_1.CreationTabConstants.EMPLOYMENTDETAILS), { replace: true });
                updateValue(FECreationTabConstant_1.CreationTabConstants.EMPLOYMENTDETAILS);
            }
            else {
                nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.addFE, "/").concat(editUserId, "/").concat(FECreationTabConstant_1.CreationTabConstants.EMPLOYMENTDETAILS));
                updateValue(FECreationTabConstant_1.CreationTabConstants.EMPLOYMENTDETAILS);
            }
        }
    };
    var renderInputFiled = function (field, values, setFieldValue, setFieldTouched, errors, touched) {
        if (!dropdownFields_1.dropdownFields.includes(field.name)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(field.inputComponent, { name: field.name, className: 'text-caps', type: 'text', key: values['baseLocation'], buttonName: field.label, placeholder: field.placeholder, required: field.required, label: field.label, swicthLabel: field.swicthLabel, value: values[field.fieldValue], defaultVal: field.defaultVal, isPastDisable: field.isPastDisable, isFutureDisable: field.isFutureDisable, isDisabled: field.isDisabled, minDate: field.minDate, maxDate: field.maxDate, require: field.require, onClick: function () { }, checked: values[field.fieldValue], onChange: function (val) {
                        setFieldValue(field.fieldValue, val);
                        setFieldTouched(field.fieldValue, true);
                    }, onKeyPress: function (e) {
                        if (field.fieldValue === 'billingCost') {
                            if (new RegExp(/[0-9]/).test(e.key) &&
                                e.target.value.length <= 17) {
                            }
                            else {
                                e.preventDefault();
                            }
                        }
                    }, onChangeHandler: onChangeHandler, handleChange: function (val) {
                        setFieldValue(field.fieldValue, val.target.checked);
                        setFieldTouched(field.fieldValue, true);
                    }, buttonState: buttonState }),
                errors[field.fieldValue] && touched[field.fieldValue] ? (React.createElement("div", { className: "error" }, errors[field.fieldValue])) : null));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(field.inputComponent, { name: field.name, className: 'text-caps', type: "text", dropDownList: getDropdownList(field.name), key: field.name === 'billingModule'
                        ? labs
                        : [], placeholder: field.placeholder, swicthLabel: field.swicthLabel, dateState: field.dateState, required: field.required, label: field.label, value: values[field.fieldValue], defaultVal: field.defaultVal, isDisabled: field.isDisabled, displayRemark: field.displayRemark, onChange: function (val) {
                        var _a;
                        if (field.name === 'billingModule') {
                            setFieldValue('billingType', (_a = appConstants_1.BILLING_COST_RULES[val.label]) !== null && _a !== void 0 ? _a : '');
                            setFieldValue('billingCost', '');
                        }
                        setFieldValue(field.fieldValue, val);
                        setFieldTouched(field.fieldValue, true);
                    } }),
                errors[field.fieldValue] && touched[field.fieldValue] ? (React.createElement("div", { className: "error" }, errors[field.fieldValue])) : null));
        }
    };
    return (React.createElement("div", { className: "form-filed-wrapper" },
        React.createElement("div", { className: "form-heaidng" },
            React.createElement("h2", null, "Billing details"),
            React.createElement("p", { className: "sub-heaidng" }, "Please update the FE's billing details")),
        React.createElement("div", null,
            React.createElement(formik_1.Formik, { validateOnBlur: false, initialValues: __assign({}, initialValues), validationSchema: schema_1.schemas.FE_BillingDetailsSchema, onSubmit: function (values) {
                    formSubmitHandler(values);
                } }, function (_a) {
                var errors = _a.errors, touched = _a.touched, values = _a.values, setFieldValue = _a.setFieldValue, resetForm = _a.resetForm, setFieldTouched = _a.setFieldTouched;
                return (React.createElement(formik_1.Form, { className: "input-fileds-wrapper" },
                    React.createElement(Grid_1.default, { container: true, columns: { xs: 12 }, columnSpacing: 3 }, formFieldConstants_1.FE_BillingDetails_Fields &&
                        formFieldConstants_1.FE_BillingDetails_Fields.map(function (section, sectionIndex) {
                            return (React.createElement(React.Fragment, { key: sectionIndex },
                                React.createElement(Grid_1.default, { item: true, xs: 9 },
                                    React.createElement("h2", { className: "label-heading heading" },
                                        section.title,
                                        section.description && (React.createElement("p", { className: "sub-heaidng label-sub-heading" }, section.description)))),
                                section.fields.map(function (field, index) {
                                    var _a, _b;
                                    if (field.fieldValue === 'billingCost') {
                                        return ((_a = values.billingModule) === null || _a === void 0 ? void 0 : _a.label) !== 'No Billing' && values.billingType === field.label ? (React.createElement(Grid_1.default, { item: true, key: index, xs: 5 }, renderInputFiled(field, values, setFieldValue, setFieldTouched, errors, touched))) : null;
                                    }
                                    if (field.fieldValue === 'billingType') {
                                        return values.billingModule !== null && ((_b = values.billingModule) === null || _b === void 0 ? void 0 : _b.label) !== 'No Billing' ? (React.createElement(Grid_1.default, { item: true, key: index, xs: 5 }, renderInputFiled(field, values, setFieldValue, setFieldTouched, errors, touched))) : null;
                                    }
                                    return (React.createElement(Grid_1.default, { item: true, key: index, xs: 5 }, renderInputFiled(field, values, setFieldValue, setFieldTouched, errors, touched)));
                                })));
                        })),
                    React.createElement("div", { className: "form-btns" },
                        React.createElement(button_component_1.default, { type: "button", buttonName: "Back", color: "yellow-outline", onClickHandler: backButtonHandler }),
                        React.createElement(button_component_1.default, { type: "submit", buttonName: 'Save & Continue', color: "yellow", isError: false }),
                        React.createElement(button_component_1.default, { type: "button", buttonName: 'Reset', color: "yellow", isError: user_id !== null &&
                                user_id !== undefined &&
                                JSON.stringify(values) !== JSON.stringify(initialValues)
                                ? false
                                : true, onClickHandler: function () { return resetForm({ values: initialValues }); } }),
                        enableSendItForApproval && (React.createElement(button_component_1.default, { buttonName: "Send it for approval", color: "blue", onClickHandler: sendItForApproval })))));
            }))));
};
exports.default = FE_BillingDetailsForm;
